import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Close } from "@mui/icons-material";

import messages from "../../../../../../../assets/locale/messages";
import Button from "../../../../../../../components/Button";
import Modal from "../../../../../../../components/Modal";
import Input from "../../../../../../../components/Input";
import { RejectBgIcon } from "../../../../../../../utils/Icons";
import { rejectVerificationRequest } from "../../../../../../../store/BusinessVerification/actions";

const RejectRequest = ({ requestType }) => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      actions: { rejectRequest }
    },
    shared
  } = messages[lang];

  const requestDetails = useSelector(
    (state) => state.businessVerification.verificationRequestMainInfo
  );

  const [modalOpen, setModalOpen] = useState(false);

  const {
    values,
    setFieldValue,
    handleSubmit,
    setFieldTouched,
    dirty,
    isValid,
    touched,
    errors
  } = useFormik({
    initialValues: {
      rejectionReason: ""
    },
    validationSchema: Yup.object().shape(
      {
        rejectionReason: Yup.string()
          .max(200, "verificationRejectionReasonMaxChar")
          .required("rejectionReasonRequired")
      },
      ["rejectionReason"]
    ),
    onSubmit: ({ rejectionReason }) => {
      dispatch(
        rejectVerificationRequest({
          data: {
            Id: requestDetails?.Id,
            Reason: rejectionReason?.trim()
          },
          requestType
        })
      );
      handleCloseModal();
    }
  });

  const handleCloseModal = () => {
    setModalOpen(false);
    setFieldValue("rejectionReason", "");
    setFieldTouched("rejectionReason", false);
  };

  const renderRejectionForm = () => (
    <form onSubmit={handleSubmit} noValidate>
      <Input
        id="rejectionReason"
        inputWrapperClass={"mt-3"}
        name="rejectionReason"
        label={rejectRequest.rejectionReason}
        placeholder={rejectRequest.typeHere}
        onChange={(value) => {
          if (!value || !!value.trim()) {
            const modifiedValue = value
              .replace(/\s\s/g, " ")
              .replace("\n\n", "\n");
            setFieldTouched("rejectionReason");
            setFieldValue("rejectionReason", modifiedValue);
          }
        }}
        value={values.rejectionReason}
        multiline
        rows={2}
        isInputHasErr={
          !!(touched.rejectionReason && errors.rejectionReason)
        }
        errMsg={errors.rejectionReason}
      />
    </form>
  );

  return (
    <div className="approve-documents">
      <Button
        label={
          <>
            <Close className="me-2" />
            {rejectRequest.btnLabel}
          </>
        }
        outlined
        danger
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && (
        <Modal
          open={modalOpen}
          icon={<RejectBgIcon />}
          title={rejectRequest.title.replace(
            ":companyName",
            requestDetails?.CompanyName || ""
          )}
          content={renderRejectionForm()}
          confirmBtnTxt={shared.reject}
          cancelBtnTxt={shared.cancel}
          handleClose={handleCloseModal}
          handleCancel={handleCloseModal}
          disableConfirmBtn={!dirty || !isValid}
          handleConfirm={handleSubmit}
          confirmBtnProps={{ danger: true }}
        />
      )}
    </div>
  );
};

export default RejectRequest;

RejectRequest.propTypes = {
  requestType: PropTypes.number.isRequired
};
